import { playGrey5 } from 'app/ui-components/design-tokens';
import styled, { css } from 'styled-components';
import { device } from '../../ui-components/breakpoints';
import { ClearFix } from '../../ui-components/utils.styles';

export const StyledHeaderElement = styled.header`
    display: inline;
`;

export const StyledHeader = styled.div`
    position: relative;
    z-index: 300;
    min-width: 100%;
    background: linear-gradient(
        to top,
        hsla(0, 0%, 0%, 0),
        hsla(0, 0%, 0%, 0.00902) 4.24%,
        hsla(0, 0%, 0%, 0.03481) 9.84%,
        hsla(0, 0%, 0%, 0.0755) 16.61%,
        hsla(0, 0%, 0%, 0.12919) 24.37%,
        hsla(0, 0%, 0%, 0.19398) 32.94%,
        hsla(0, 0%, 0%, 0.268) 42.13%,
        hsla(0, 0%, 0%, 0.34935) 51.75%,
        hsla(0, 0%, 0%, 0.43615) 61.63%,
        hsla(0, 0%, 0%, 0.5265) 71.58%,
        hsla(0, 0%, 0%, 0.61852) 81.41%,
        hsla(0, 0%, 0%, 0.71031) 90.95%,
        hsla(0, 0%, 0%, 0.8)
    );

    visibility: hidden;

    ${(props) =>
        props.isSticky &&
        css`
            top: 0px;
            border-top: 1px transparent;
            position: sticky;
            z-index: 300;
            min-width: 100%;
            background: ${playGrey5};
        `}

    ${(props) =>
        props.isVisible &&
        css`
            visibility: visible;
        `}
`;

export const GlobalHeader = styled.div`
    ${ClearFix};
    padding: 15px 0 5px;
    margin: 0 auto;
    max-width: 100%;

    @media print {
        display: none !important;
    }

    @media ${device.GteSmall} {
        padding: 15px 0;
    }

    @media ${device.GteMedium} {
        margin-bottom: 0;
        padding: 20px 0;

        ${(props) =>
            props.isThin &&
            css`
                padding: 15px 0;
            `};
    }
`;
